var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"multidimensional pt-4 pl-4 pr-4",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }